import { detectVisibleItem, isMobileScreen } from './utils';
import { tabsHandler } from './tabs';
import { dropdownHandler } from './dropdown';
import { BREAKPOINTS } from './constants';

const onDetectVisibleCard = (card, dots) => {
  if (!dots.length) return;
  const dotsArr = Array.from(dots);
  const currentActiveCard = dotsArr?.[0].querySelector('[data-active]');
  const currentCard = card?.getAttribute('data-card-value');
  const cardIndex = Number(currentCard);

  currentActiveCard?.removeAttribute('data-active');
  dotsArr?.[0].children?.[cardIndex - 1]?.setAttribute('data-active', '');

};

const carouselHandler = (carousel) => {
  let isDragStart = false;
  let prevPageX = 0;
  let prevScrollLeft = 0;

  const onDragStart = (e) => {
    isDragStart = true;
    prevPageX = e.pageX || e.touches[0].pageX;
    prevScrollLeft = carousel.scrollLeft;
  };

  const onDragging = (e) => {
    if (!isDragStart) return;
    const positionDiff = (e.pageX || e.touches[0].pageX) - prevPageX;
    carousel.scrollLeft = prevScrollLeft - positionDiff;
  };

  const onDragStop = () => isDragStart = false;

  carousel.addEventListener('mousedown', onDragStart);
  carousel.addEventListener('touchstart', onDragStart, { passive: true });

  carousel.addEventListener('mousemove', onDragging);
  carousel.addEventListener('touchmove', onDragging, { passive: true });

  carousel.addEventListener('mouseup', onDragStop);
  carousel.addEventListener('touchend', onDragStop, { passive: true });
};

const updateDots = (length, dots) => {
  if (!dots[0]) return;
  let html = '';

  if (length === 1 || !length) return dots[0].innerHTML = '';

  for (let i = 0; i < length; i++) {
    html += i === 0 ? '<li data-active></li>' : '<li></li>';
  }

  dots[0].innerHTML = html;

};

const onTabDropdownSelect = (value, leadershipOptions, dots) => leadershipOptions.forEach((item) => {

  if (item.getAttribute('data-leadership-tab-value') === value) {
    item.classList.remove('hidden');
    if (isMobileScreen(BREAKPOINTS.XXL)) {
      updateDots(item?.children?.length, dots);
    }
    return;
  }
  item.classList.add('hidden');
});

const onLeadreshipModuleLoad = () => {
  const leadershipModuleSection = document.querySelector('[data-leadership]');
  if (!leadershipModuleSection) return;
  const leadershipOptions = leadershipModuleSection.querySelectorAll('[data-leadership-tab-value]');
  const dots = leadershipModuleSection.querySelectorAll('[data-leadership-dots]');
  const dropdown = leadershipModuleSection.querySelector('[data-dropdown]');
  const tabs = leadershipModuleSection.querySelector('[data-tabs]');

  if (isMobileScreen(BREAKPOINTS.XXL)) {
    dropdownHandler(dropdown, (value) => {
      onTabDropdownSelect(value, leadershipOptions, dots);
      const leadershipCarousel = leadershipModuleSection.querySelector(`[data-leadership-tab-value="${value}"]`);
      carouselHandler(leadershipCarousel);
      const articles = leadershipCarousel.querySelectorAll('article');
      detectVisibleItem(articles, (card) => onDetectVisibleCard(card, dots));
    });
    return;
  }
  const leadershipCarousel = leadershipModuleSection.querySelector('.leadership_carousel');

  tabsHandler(tabs, leadershipCarousel, (value) => onTabDropdownSelect(value, leadershipOptions));

};

export default onLeadreshipModuleLoad;
